/* This file is a copy of the existing file defined in the Settings app.           */
/* It displays OLDER API keys format. So, it is a temporary logic before creating  */
/* GKD API keys. */
import { AlertBannerWarning, ParagraphTertiary, SeparatorSecondary, SpacerVertical, SwitchCheckbox } from '@klarna/bubble-ui';
import { Flex, Modal } from '@klarna/mp-ui';
import { hooks as i18nHooks } from 'mage-i18n';
import React, { useState } from 'react';
import DownloadLocalDataLink from './DownloadLocalDataLink';
import { propertiesToMap } from './utils';
const TRANSLATION_PREFIX = 'home-fe.boosters-plugin.instructions.api-key.success-modal';
function mapAddCredentialMutation(data) {
    var _a;
    return propertiesToMap((_a = data === null || data === void 0 ? void 0 : data.createMerchantApiCredentials) === null || _a === void 0 ? void 0 : _a.properties);
}
function AddApiCredentialSuccessModal({ data, onClose }) {
    const t = i18nHooks.useTranslator();
    const [hasDownloaded, setHasDownloaded] = useState(false);
    const [hasAcknowledged, setHasAcknowledged] = useState(false);
    const hasSaved = hasDownloaded || hasAcknowledged;
    const { username, password } = mapAddCredentialMutation(data);
    const downloadData = `username: ${username}\npassword: ${password}`;
    return (React.createElement(Modal, { useWindowHeight: false, closeOnClickOutside: false, closeOnEscape: false, title: t(`${TRANSLATION_PREFIX}.title`), description: t(`${TRANSLATION_PREFIX}.description`), buttonPrimary: {
            text: t('home-fe.common.close'),
            onClick: onClose,
            disabled: !hasSaved,
            'data-testid': 'confirmation-button'
        } },
        React.createElement("div", { style: { padding: '20px 0' } },
            React.createElement(Flex, { id: 'credentials-username', justifyContent: 'space-between' },
                React.createElement(ParagraphTertiary, { correctFootprint: true }, t('home-fe.common.username')),
                React.createElement(ParagraphTertiary, { medium: true, correctFootprint: true }, username))),
        React.createElement(SeparatorSecondary, null),
        React.createElement("div", { style: { padding: '20px 0' } },
            React.createElement(Flex, { id: 'credentials-password', justifyContent: 'space-between' },
                React.createElement(ParagraphTertiary, { correctFootprint: true }, t('home-fe.common.password')),
                React.createElement(ParagraphTertiary, { medium: true, correctFootprint: true }, password))),
        React.createElement(SpacerVertical, { medium: true }),
        React.createElement(DownloadLocalDataLink, { id: 'credentials', data: downloadData, filename: `${username}.txt`, onClick: () => setHasDownloaded(true) }),
        React.createElement(SpacerVertical, { medium: true }),
        React.createElement(AlertBannerWarning, { content: [t(`${TRANSLATION_PREFIX}.warning`)] }),
        React.createElement(SpacerVertical, { medium: true }),
        React.createElement(SwitchCheckbox, { id: 'credentials-checkbox', checked: hasAcknowledged, onChange: setHasAcknowledged }, t(`${TRANSLATION_PREFIX}.checkbox`))));
}
export default AddApiCredentialSuccessModal;
